import React from 'react';
import '../../news-pages.css';
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

import cover from './cover.jpg'
import pic1 from './pic1.jpg'
import pic2 from './pic2.jpg'
import pic3 from './pic3.jpg'
import pic4 from './pic4.jpg'
import pic5 from './pic5.jpg'
import pic6 from './pic6.jpg'
import pic7 from './pic7.jpg'
import pic8 from './pic8.jpg'

const Id22 = () => {

    const detail = 
        {
            id:22,
            imgSrc:pic1,
            ini:'Training on Arboviruses Culture and Neutralization Testing',
            href:'',
            element:'',
            topic:'',
            inform:`The LMI PRESTO recently organized a specialized training program on arboviruses culture and neutralization testing, in collaboration with the LUCENT International Collaboration. 
                    <br><br> The training was conducted by experts from IRD MIVEGEC, Montpellier — Dr. Dorothée Missé and Dr. Isabelle Conclois — together with Dr. Ai-rada Pintong from Faculty of Medicine, Kasetsart University.
                    The program took place from 20–31 October 2025 at the AMS Integrated Academic Excellence Center (AMS-IAEC), Faculty of Associated Medical Sciences, Chiang Mai University.
                    <br><br> This hands-on course aimed to enhance technical skills and deepen scientific understanding among researchers and staff. Participants engaged in laboratory demonstrations and discussions covering essential techniques such as virus isolation, culture maintenance, and neutralization assays.
                    <br><br> The collaborative environment fostered valuable knowledge exchange and strengthened existing international scientific partnerships. We extend our sincere gratitude to all collaborators for their generous guidance and expertise. This training marks a significant step forward in our ongoing commitment to advancing arboviral research and global public health`
        ,
            link1:`https://www.facebook.com/photo.php?fbid=820865294250958&set=a.115086791495482&type=3`,
     }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }

    const imgs = [
        {
            imageSrc: cover,
            alt: 'cover',
            title: 'cover',
            thumbnailImageSrc: cover
        },
        {
            imageSrc: pic1,
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: pic1
        },
        {
            imageSrc: pic2,
            alt: 'pic2',
            title: 'pic2',
            thumbnailImageSrc: pic2
        },
        {
            imageSrc: pic3,
            alt: 'pic3',
            title: 'pic3',
            thumbnailImageSrc: pic3
        },
        {
            imageSrc: pic4,
            alt: 'pic4',
            title: 'pic4',
            thumbnailImageSrc: pic4
        },
        {
            imageSrc: pic5,
            alt: 'pic5',
            title: 'pic5',
            thumbnailImageSrc: pic5
        },
        {
            imageSrc: pic6,
            alt: 'pic6',
            title: 'pic6',
            thumbnailImageSrc: pic6
        },
        {
            imageSrc: pic7,
            alt: 'pic7',
            title: 'pic7',
            thumbnailImageSrc: pic7
        },
        {
            imageSrc: pic8,
            alt: 'pic8',
            title: 'pic8',
            thumbnailImageSrc: pic8
        },
        
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
                <div className="btn">
                    <h2>MORE INFORMATION</h2>
                    <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
        </div>
    );
}

export default Id22;
